// Copyright (c) Docugami, Inc. All rights reserved.

import { ChunkSlotItem, ISlotItem, SlotItemType } from "components/cards/ItemSlot";
import { useMemo } from "react";
import { useDocumentDgml } from "./documentDgml";
import { useAppDispatch } from "./redux";
import { spanIdObjectReadingOrderComparerThunk } from "./reportEntrySlots";

export const useSlotsForSuggestions = (suggestions: string[]): ISlotItem[] => {
    const dgml = useDocumentDgml();
    const dispatch = useAppDispatch();

    return useMemo(() => {
        if (!dgml.isInitialized()) {
            return [];
        }

        const slots: ChunkSlotItem[] = [];
        for (const spanId of suggestions) {
            const instance = dgml.getInstanceById(spanId);
            if (!!instance) {
                const slot: ChunkSlotItem = {
                    type: SlotItemType.Chunk,
                    id: spanId,
                    spanId: instance.spanId,
                }

                slots.push(slot);
            }
        }

        return dispatch(spanIdObjectReadingOrderComparerThunk(slots))
    }, [dgml, suggestions, dispatch])
}